import type React from "react";
import type Highcharts from "highcharts/es-modules/masters/highcharts.src.js";
import { Chart } from "@highcharts/react";
import { useAppSelector } from "../../redux/hooks";
import { formatCurrency, formatNumber, formatPercent } from "../../utils/formatNumber";
import type { FunnelChartEntry, FormatType } from "./types";
interface FunnelChartProps {
  data: FunnelChartEntry[];
  format?: FormatType;
  title?: string;
}
const FunnelChart: React.FC<FunnelChartProps> = ({ data, format, title = "" }) => {
  const marketPlace = useAppSelector((state) => state.marketPlace);
  const total = data.reduce((sum, d) => sum + d.y, 0);
  const options: Highcharts.Options = {
    chart: {
      type: "funnel",
      marginLeft: 40,
      marginRight: 110,
      marginBottom: 50,
    },

    title: {
      text: title,
    },
    tooltip: {
      useHTML: true,
      formatter: function (this: Highcharts.Point): string {
        const formattedValue =
          format === "currency" ?
            formatCurrency(this.y ?? 0, {
              marketPlace: marketPlace.marketPlace,
            })
          : formatNumber(this.y);
        const percentage = formatPercent((this.y ?? 0) / total, {
          decimalPlaces: 1,
        });
        const title = this.name;
        if (total) {
          return `<div style="text-align: center">
                            <div style="font-size: 1.7em; font-weight: bold;">${title.charAt(0).toUpperCase() + title.slice(1)}</div>
                            <div style="font-size: 1.3em;">
                            ${formattedValue} <strong>(${percentage})</strong>
                            </div>
                        </div>`;
        }

        return "<span><strong>" + this.name + ":</strong><br />" + formattedValue + "</span>";
      },
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          useHTML: true,
          crop: false,
          overflow: "allow",
          formatter: function (this: Highcharts.Point) {
            const formattedValue =
              format === "currency" ?
                formatCurrency(this.y ?? 0, {
                  marketPlace: marketPlace.marketPlace,
                })
              : formatNumber(this.y);
            const title = this.name;
            const percentage = formatPercent((this.y ?? 0) / total, {
              decimalPlaces: 1,
            });
            return (
              `<span style="font-size: 2em; font-weight: 900;">${title.charAt(0).toUpperCase() + title.slice(1)}</span><br>` +
              `<span style="opacity: 0.6;font-size:1.3em; margin: auto; display: block; text-align: center; width: 100%;">${formattedValue} - ${percentage}</span>`
            );
          },
        },
      },
    },

    series: [
      {
        type: "funnel",
        name: "Metric",
        data: data,
      },
    ],
  };

  return <Chart options={options} />;
};

export default FunnelChart;
